module.exports = __webpack_public_path__ + "img/service-main-2.913291c9.png";